// ============================================================================
// PORTUGUESE TRANSLATIONS - UI
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'pt',
    languageName: 'Português',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Crônicas\ndo Amor",
    subtitle: "Descoberta Interativa das Escrituras",
    tagline: "Caminhar para a luz divina",
    menu: "Menu",
    retry: "Tentar novamente"
  },
  
  buttons: {
    play: "JOGAR",
    back: "Voltar",
    continue: "Continuar",
    restart: "Reiniciar",
    close: "Fechar",
    nextLevel: "Próximo Nível",
    selectLevel: "Seleção de Níveis",
    retry: "Tentar Novamente",
    mainMenu: "Menu Principal",
    start: "Começar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    save: "Salvar",
    load: "Carregar",
    yesRestart: "Sim, reiniciar",
    noContinue: "Não, continuar",
    tryAgain: "Tentar novamente",
    backToMenu: "Voltar ao menu"
  },
  
  labels: {
    score: "Pontuação",
    stars: "Estrelas",
    wisdom: "Sabedoria",
    revelation: "Revelação",
    lives: "Vidas",
    combo: "Combo",
    level: "NÍVEL",
    easy: "FÁCIL",
    medium: "MÉDIO",
    hard: "DIFÍCIL",
    correct: "Correto!",
    gameOver: "Prova Falhada",
    victory: "Vitória!",
    completed: "Completado",
    rank: "Classificação Espiritual",
    points: "Pontos de Sabedoria",
    unlockedLevels: "nível(eis) desbloqueado(s)",
    questionOfKnowledge: "Pergunta de Conhecimento",
    hintOfWisdom: "Dica de Sabedoria",
    knowledgeMastered: "Conhecimento Dominado!",
    knowledgeAcquired: "Conhecimento Adquirido!",
    testFailed: "Prova Falhada",
    wisdomBonus: "Bônus",
    xpGained: "XP",
    newRank: "Novo posto",
    nextGrade: "Próximo grau",
    maxLevelReached: "Nível máximo alcançado!",
    wrongAnswer: "Resposta errada!"
  },
  
  menu: {
    playButton: "JOGAR",
    info: "Info",
    treasures: "Tesouros",
    john: "João",
    reset: "Reiniciar",
    resetConfirm: "Reiniciar aventura?",
    resetWarning: "Tem certeza de que deseja apagar todo o seu progresso?",
    resetLose: "você perderá:",
    wisdomPoints: "Pontos de Sabedoria",
    starsCollected: "estrelas coletadas",
    levelsUnlocked: "níveis desbloqueados",
    spiritualRank: "Posto Espiritual",
    yesRestart: "Sim, reiniciar",
    noContinue: "Não, continuar",
    newAdventure: "Nova Aventura",
    readyToStart: "Pronto para começar?",
    startJourney: "Comece sua jornada no conhecimento das Escrituras!",
    audioControls: "Controles de áudio",
    mute: "Silenciar",
    unmute: "Ativar som",
    close: "Fechar",
    language: "Idioma",
    restartGame: "Reiniciar jogo"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Aventura bíblica interativa",
    anonymousMode: "Jogar Anônimo",
    anonymousDesc: "Escolha um apelido",
    emailMode: "Login por Email",
    emailDesc: "Salvamento multi-dispositivo",
    pseudo: "Apelido",
    pseudoPlaceholder: "Seu apelido...",
    email: "Endereço de Email",
    emailPlaceholder: "seu@email.com",
    startPlaying: "Começar a jogar",
    sendLink: "Enviar link",
    sending: "Enviando...",
    connecting: "Conectando...",
    back: "Voltar",
    localSave: "Seu progresso será salvo localmente",
    cloudSync: "Sem senha necessária • Sincronização na nuvem",
    magicLink: "Receba um link mágico por email",
    checkEmail: "📧 Verifique seu email! Um link de login foi enviado.",
    checkSpam: "Verifique também sua pasta de spam",
    waitingConnection: "Aguardando conexão...",
    errorSend: "Erro ao enviar link",
    rateLimited: "⏳ Por favor, aguarde 15 segundos antes de reenviar um email",
    importSession: "🔄 Importar sessão da produção",
    errorConnection: "Erro de conexão",
    enterPseudo: "Por favor, insira um apelido",
    enterEmail: "Por favor, insira um email válido",
    // Tooltips
    never: "Nunca",
    save: "Salvar jogo",
    lastSave: "última",
    refresh: "Recarregar progresso",
    logout: "Desconectar",
    connectToCloud: "Conectar para salvar online",
    editPseudo: "Editar usuário",
    confirm: "Confirmar",
    cancel: "Cancelar",
    close: "Fechar",
    passwordMode: "Login Simples",
    passwordDesc: "Email + senha",
    password: "Senha",
    passwordPlaceholder: "Mínimo 6 caracteres",
    passwordMinLength: "Mínimo 6 caracteres",
    playWithoutAccount: "Jogar sem conta",
    forgotPassword: "Esqueceu a senha?",
    resetPasswordTitle: "Redefinir Senha",
    resetPasswordSubtitle: "Digite seu email para receber um link de redefinição",
    sendResetLink: "Enviar Link",
    resetEmailSent: "📧 Email de redefinição enviado! Verifique sua caixa de entrada.",
    errorReset: "Erro ao enviar o email",
    backToSignin: "Voltar ao Login",
    newPassword: "Nova Senha",
    enterNewPassword: "Escolha uma nova senha segura",
    confirmPassword: "Confirmar Senha",
    updatePassword: "Atualizar Senha",
    passwordsDontMatch: "As senhas não correspondem",
    passwordUpdateSuccess: "✅ Senha atualizada com sucesso!",
    errorUpdatePassword: "Erro ao atualizar a senha",
    resetLinkExpired: "Link de redefinição expirado ou inválido",
    forgotPassword: "Esqueceu a senha?",
    signup: "Cadastrar",
    signin: "Entrar",
    createAccount: "Criar Conta",
    signupInfo: "Preencha o formulário abaixo",
    passwordInfo: "Acesso rápido com senha",
    signupButton: "Criar Minha Conta",
    signinButton: "Entrar",
    passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
    emailAlreadyExists: "Este email já está em uso",
    emailExistsHint: "✉️ Este email já está registrado. Tente fazer login! (Talvez criado de outro jogo?)",
    switchToSignin: "🔑 Mude para o modo Entrar com seu email existente",
    invalidCredentials: "Email ou senha inválidos",
    signupSuccess: "📧 Conta criada! Verifique seu email para confirmar seu registro.",
    emailConfirmationRequired: "Verifique sua caixa de entrada para ativar sua conta",
    checkSpamFolder: "Lembre-se de verificar sua pasta de spam/lixo eletrônico",
    connectionSuccess: "✅ Login bem-sucedido!",
    errorSignup: "Erro ao se cadastrar"},
  
  install: {
    title: "Instalar o aplicativo",
    subtitle: "Acesso rápido e offline",
    feature1: "Lançamento instantâneo da tela inicial",
    feature2: "Funciona offline após a instalação",
    feature3: "Experiência de aplicativo nativo",
    feature4: "Nenhum download de loja necessário",
    install: "Instalar",
    dismiss: "Depois",
    info: "Você pode desinstalar o app a qualquer momento"
  },
  
  ranks: {
    seeker: "Buscador",
    believer: "O Desperto",
    disciple: "Discípulo",
    servant: "Servo",
    witness: "Testemunha",
    guardian: "Guardião",
    wise: "Sábio",
    prophet: "Profeta",
    apostle: "Apóstolo",
    seekerDesc: "Início da jornada espiritual",
    believerDesc: "Consciência espiritual despertada",
    discipleDesc: "Aprendizado dos ensinamentos",
    servantDesc: "Serviço e devoção",
    witnessDesc: "Compartilhar a fé",
    guardianDesc: "Proteção da verdade",
    wiseDesc: "Sabedoria e conhecimento",
    prophetDesc: "Visão espiritual",
    apostleDesc: "Mestre espiritual"
  },

  spiritualJourney: {
    beginning: "Início da jornada espiritual",
    progress: "Progresso espiritual",
    grade: "Grau",
    xp: "XP",
    level: "Nível",
    nextGrade: "Próximo grau",
    still: "Ainda",
    maxLevelReached: "Nível Máximo Alcançado!",
    masteredAllTeachings: "Você dominou todos os ensinamentos",
    progression: "Progressão"
  },
  
  treasures: {
    title: "📖 Tesouros da Bíblia",
    verse: "Versículo do dia",
    fact: "você sabia?",
    treasure: "Tesouro escondido",
    question: "Pergunta curiosa",
    context: "Contexto",
    strongReference: "Referência bíblica para estudo aprofundado",
    verseOfDay: "🃏 Versículo do dia",
    didYouKnow: "🤔 você sabia?",
    hiddenTreasure: "💎 Tesouro escondido",
    funnyQuestion: "😄 Pergunta curiosa",
    emmanuelMemo: "Nota de Emmanuel",
    emmanuelMessage: "você chegou ao topo da montanha, e o conhecimento está adquirido. Mas a fé inabalável requer experiência de vida, misericórdia e verdadeiro amor de Jesus. As várias provações da vida testarão seu caminho, o verdadeiro caminho que escolhemos, nosso coração. Permanecemos imperfeitos, nossos desejos são numerosos, e o amor ao lucro ou ao nosso conforto pessoal torna-se com frequência nossa prioridade egoísta. Peça a Deus sabedoria, seu amor, sua força, e reconheça humildemente suas fraquezas, pois nada pode ser escondido Dele... Nada. Não há necessidade de navegar em modo privado, usar VPN, ou mesmo apagar o histórico. Jejue como Daniel: prive-se por um momento do que você mais ama, na calma e na sabedoria. Isso permitirá que você ouça melhor a Deus, tenha uma disposição de coração pronta para transformações profundas - e muitas vezes dolorosas. Então os sonhos e visões se tornarão mais claros, como para José. Mas guarde-se do orgulho: não ceda a 'Eu sempre tenho razão' ou 'Eu sei melhor'. Porque a revelação de Deus é uma graça extraordinária. Não se torne um doutor da Lei, capaz de crucificar Jesus novamente hoje, Ele que simplesmente pede para amar seu próximo... e conceder-lhes a mesma liberdade que você recebe. Ter fé significa entrar em um relacionamento livre e uma jornada do coração. Isso fará de você heróis poderosos, capazes do impossível. Porque a experiência do sobrenatural, a presença de Deus, sua confirmação ou bênção o tornará verdadeiramente inabalável.",
    jesusIsNot: "❌ Esclarecimento importante",
    clarification: "Esclarecimento importante",
    bibleOffline: "Ler Bíblia Offline",
    bibleStudy: "Estudo bíblico",
    version: "Versão",
    openReader: "Abrir leitor",
    features: "Recursos"
  },
  
  messages: {
    chooseCard: "🃏 Escolha sua carta de poder",
    cardHelp: "Ela acompanhará você nas 3 perguntas deste nível",
    chooseAnswer: "📖 Escolha sua resposta:",
    wrongAnswer: "❌ Resposta errada! você tem {lives} vida(s) restante(s). Tente novamente!",
    levelCompleted: "Nível {level} Completado",
    questionsProgress: "Pergunta {current} de 3",
    starsCollected: "Estrelas coletadas: {current}/{total}",
    pointsEarned: "+{points} Pontos de Sabedoria",
    defeatedQuote: "Tudo posso naquele que me fortalece",
    chapter: "Capítulo",
    chapterStars: "estrelas do capítulo",
    totalGlobal: "Total global",
    backToMenu: "Voltar ao Menu"
  },
  
  quotes: {
    wisdom: "O temor do Senhor é o princípio da sabedoria",
    faith: "Tudo posso naquele que me fortalece",
    hope: "O Senhor é meu pastor, nada me faltará",
    love: "Porque Deus amou o mundo de tal maneira...",
    perseverance: "A fé requer perseverança",
    defeat: "O fracasso convida a crescer no conhecimento"
  },

  cards: {
    faith: "Fé",
    courage: "CORAGEM",
    wisdom: "SABEDORIA",
    faithKnowledge: "+50% pontos",
    courageKnowledge: "Segunda chance",
    wisdomKnowledge: "Dica + bônus",
    faithDesc: "Máximo de pontos de sabedoria obtidos",
    courageDesc: "Pontos normais mas segunda chance",
    wisdomDesc: "Dica revelada e +25% pontos",
    chooseCard: "🃏 Escolha um dom de conhecimento",
    cardEffects: "🃏 Efeitos dos dons de conhecimento:",
    faithEffect: "+50% pontos de sabedoria - Recompensa máxima",
    courageEffect: "Pontos normais mas segunda chance em erro",
    wisdomEffect: "+25% pontos + dica revelada para cada pergunta",
    chooseWisely: "Escolha com sabedoria, pois sua escolha te acompanhará por todo o nível"
  },

  challenge: {
    loading: "Carregando o nível...",
    peace: "🕊️ Que a paz repouse em sua casa",
    questionsAwaiting: "🎯 3 perguntas de conhecimento te aguardam",
    starsQuote: "Cada estrela é um passo em direção à luz divina"
  },

  chapters: {
    "1": "Gênesis",
    "2": "Êxodo",
    "3": "Jesus Cristo",
    "4": "Crucificação/Ressurreição",
    "5": "Igreja Primitiva",
    "6": "Missões de Paulo",
    "7": "Cartas/Apocalipse",
    "8": "Nível Bônus"
  },

  bible: {
    readerTitle: "📖 Leitor da Bíblia",
    loading: "Carregando as Escrituras...",
    menu: "Menu",
    tabBible: "Bíblia",
    tabUnity: "Unidade",
    strong: "Strong",
    strongReferences: "Referências Strong",
    verses: "versículos",
    previous: "Anterior",
    next: "Próximo",
    strongDefinition: "Referência Strong",
    word: "Palavra original",
    transliteration: "Transliteração",
    pronunciation: "Pronúncia",
    meaning: "Significado",
    definition: "Definição completa",
    usage: "Uso bíblico",
    etymology: "Etimologia",
    close: "Fechar",
    moreReferences: "e {{count}} outras referências",
    copyright: "📖 Domínio público • Strong"
  },

  bibleResources: {
    inAppReader: {
      name: "Ler no App",
      description: "Leitor de Bíblia integrado com Strong",
      features: {
        offline: "Offline",
        strong: "Números Strong",
        navigation: "Navegação"
      }
    }
  },

  philosophy: {
    title: "Dimensão filosófica",
    loveOntology: "O amor como princípio ontológico",
    loveDescription: "Jesus transforma o amor em fundamento metafísico: amar a Deus e ao próximo torna-se a própria estrutura do ser autêntico. O amor transcende a moral para se tornar modo de existência.",
    newCommandment: "O Novo Mandamento",
    jesusEmphasizes: "Quando Jesus dá um novo mandamento, ele enfatiza o verbo amar",
    loveGod: "Ame a Deus de todo o seu coração",
    loveNeighbor: "Ame o seu próximo como a si mesmo",
    lovePriority: "O amor torna-se uma prioridade"
  },

  footer: {
    version: "Versão 1.0 • 2024",
    dedication: "Desenvolvido para a glória de Deus"
  },

  endCredits: {
    lines: [
      { text: "você chegou ao topo da montanha", delay: 2000 },
      { text: "você aprendeu muitas coisas", delay: 2000 },
      { text: "Sua fé cresce a cada dia", delay: 2000 },
      { text: "você vive coisas lindas com Deus", delay: 2000 },
      { text: "As dificuldades ajudam você a crescer", delay: 2000 },
      { text: "Elas mostram o que é importante", delay: 2000 },
      { text: "Seja humilde como uma criança pequena", delay: 2000 },
      { text: "Deus ama seu coração simples", delay: 2000 },
      { text: "Na calma você ouve Deus", delay: 2000 },
      { text: "O jejum liberta seu espírito", delay: 2000 },
      { text: "Ore e Deus te guiará", delay: 2000 },
      { text: "O orgulho esconde a verdade", delay: 2000 },
      { text: "A graça de Deus é magnífica", delay: 2000 },
      { text: "Ela vem do coração de Deus", delay: 2000 },
      { text: "A verdadeira fé te torna livre", delay: 2000 },
      { text: "Ela te une a Deus para sempre", delay: 2000 },
      { text: "O amor pode mudar tudo", delay: 2000 },
      { text: "Pode fazer milagres", delay: 2000 },
      { text: "Repita comigo", delay: 2000 },
      { text: "Jesus, eu te dou meu coração", delay: 3000 },
      { text: "você é meu rei, meu salvador", delay: 3000 },
      { text: "Venha transformar minha vida", delay: 3000 },
      { text: "O caminho continua agora", delay: 2000 },
      { text: "Compartilhe esta luz linda", delay: 2000 },
      { text: "Rumo à vida que nunca acaba", delay: 2000 },
      { text: "Guarde o amor em seu coração", delay: 3000 },
      { text: "Como um tesouro precioso", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "PARABÉNS!",
      proud: "ESTAMOS ORGULHOSOS DE VOCÊ",
      courage: "GUERREIRO CORAJOSO",
      peace: "PORTADOR DE PAZ",
      child: "FILHO DE DEUS",
      blessing: "QUE DEUS TE ABENÇOE",
      continue: "Continuar"
    }
  },

  mountain: {
    spiritualAscension: "Ascensão Espiritual",
    levelProgress: "Nível {{level}} • {{stars}} estrelas obtidas",
    combo: "Combo",
    perfectMessage: "\"Porque os meus pensamentos não são os vossos pensamentos\" - O cordeiro sobe em direção à sabedoria perfeita",
    goodMessage: "\"Buscai e encontrareis\" - A ascensão continua em direção à verdade",
    startMessage: "\"A fé, mesmo pequena como um grão de mostarda\" - Primeiro passo em direção à luz",
    skipAnimation: "Pular animação",
    chapter: "Capítulo",
    chapterProgress: "Capítulo {{current}}/{{total}}",
    secret: "Segredo",
    waypoints: {
      start: "Início",
      firstSlope: "Primeira encosta",
      lastSlope: "Última encosta"
    },
    status: {
      defeat: "Derrota",
      inProgress: "Em andamento",
      victory: "Vitória"
    }
  },

  validation: {
    pseudoTooShort: "O nome de usuário deve conter pelo menos 2 caracteres",
    enterPseudo: "Por favor, insira um nome de usuário"
  },

  pseudoSetup: {
    title: "Escolha seu nome de usuário",
    confirm: "Confirmar Nome"
  },

  navigation: {
    back: "Voltar"
  },

  console: {
    starsUnlocked: "estrelas alcançadas! Desbloqueando capítulo",
    defeatAnimation: "Derrota... J.C. desce"
  },

  errors: {
    progressionError: "Erro de progressão",
    invalidProgressionData: "Dados de progressão inválidos:"
  },

  levels: {
    chaptersAndBonus: "8 capítulos + nível bônus",
    bonusUnlocked: "🎁 NÍVEL BÔNUS DESBLOQUEADO! Você alcançou a perfeição espiritual!",
    starsToDiscover: "273 {stars} para descobrir",
    starsPerLevel: "3 {stars} por nível"
  },

  architecture: {
    title: "⚙️ Arquitetura técnica",
    react: {
      name: "React",
      description: "Interface moderna"
    },
    modules: {
      name: "Módulos",
      description: "Carregamento dinâmico"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Armazenamento local"
    },
    tailwind: {
      name: "Tailwind",
      description: "Design responsivo"
    }
  },

  gameManager: {
    title: "Salvamento de jogo",
    saveLocal: "Salvamento local",
    saveCloud: "Nuvem sincronizada",
    saveWaiting: "Aguardando conexão",
    lastSave: "Último salvamento:",
    never: "Nunca",
    saving: "Salvando...",
    save: "Salvar",
    loadProgress: "Carregar",
    loading: "Carregando...",
    autoSaveEnabled: "💾 Salvamento automático ativado",
    saveError: "❌ Erro ao salvar",
    gameSaved: "✅ Jogo salvo!",
    gameLoaded: "✅ Jogo carregado!"
  },

  info: {
    title: "Unity Quest Crônicas da Paz",
    subtitle: "Descoberta interativa das Escrituras",
    yourStats: "Suas Estatísticas",
    score: "Pontuação",
    wisdom: "Sabedoria",
    revelation: "Revelação",
    createdWith: "Criado com ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "Desenvolvedor apaixonado por espiritualidade",
    artistModule: "Emmanuel Artista",
    artistPortfolio: "Portfólio artístico e criações digitais",
    features: "Recursos",
    multipleChapters: "91 níveis distribuídos em 8 capítulos bíblicos",
    powerCards: "3 cartas de poder únicas (Fé, Coragem, Sabedoria)",
    progressionSystem: "Sistema de progressão com postos espirituais",
    bibleTreasures: "Tesouros bíblicos e fatos interessantes",
    howToPlay: "Como Jogar",
    selectLevel: "Selecione um nível desbloqueado",
    choosePowerCard: "Escolha sua carta de poder",
    answerQuestions: "Responda às 3 perguntas de conhecimento",
    earnStars: "Ganhe estrelas de acordo com as vidas restantes",
    tips: "Dicas",
    readCarefully: "Leia cada pergunta com atenção",
    useWisdomCard: "Use a carta Sabedoria para obter dicas",
    courageGivesSecondChance: "A carta Coragem te dá uma segunda chance",
    faithMaximizes: "A carta Fé maximiza seus pontos",
    johnGospelTitle: "Evangelho de João",
    johnGospelStats: "21 capítulos • 878 versículos • 14 idiomas",
    bibleReaderStrong: "Leitor Bíblico + Strong",
    bibleReaderStrongDesc: "Leitura completa com dicionário Strong",
    johnTreasures: "Tesouros de João",
    johnTreasuresDesc: "Tesouros bíblicos e fatos interessantes",
    quickAccessChapters: "Acesso rápido a capítulos famosos:",
    johnChapter1: "Prólogo",
    johnChapter3: "Nascer de novo",
    johnChapter14: "Eu sou o caminho",
    johnChapter20: "Ressurreição",
    version: "Versão",
    madeWithLove: "Feito com amor para a glória de Deus",
    backToMenu: "Voltar ao Menu"
  },

  bible: {
    readerTitle: "📖 Leitor da Bíblia",
    johnReaderTitle: "Leitor da Bíblia - Evangelho de João",
    john: "João",
    loading: "Carregando as Escrituras...",
    loadingChapter: "Capítulo {chapter} do Evangelho de João. Os dados completos estão carregando...",
    exploreWhileLoading: "Enquanto isso, você pode explorar outros capítulos ou usar a função de pesquisa.",
    menu: "Menu",
    tabBible: "Bíblia",
    tabUnity: "Unidade",
    strong: "Strong",
    strongReferences: "Referências Strong",
    verses: "versículos",
    previous: "Anterior",
    next: "Próximo",
    strongDefinition: "Referência Strong",
    word: "Palavra original",
    transliteration: "Transliteração",
    close: "Fechar",
    share: "Compartilhar",
    shareVerse: "Compartilhar este versículo",
    shareSelection: "Compartilhar a seleção",
    pronunciation: "Pronúncia",
    meaning: "Significado",
    definition: "Definição completa",
    usage: "Uso bíblico",
    etymology: "Etimologia",
    search: "Buscar...",
    definitionNotFound: "Definição não encontrada",
    definitionLoading: "Definição a carregar...",
    imageFeatureComing: "🖼️ Recurso de imagem em breve!",
    copyError: "Erro ao copiar:",
    error: "❌ Erro",
    errorLoading: "Erro ao carregar",
    retry: "Tentar novamente",
    readerInDevelopment: "Leitor da Bíblia de João em desenvolvimento...",
    verseCopied: "Versículo copiado para a área de transferência!",
    moreReferences: "e {{count}} outras referências",
    copyright: "📖 LSG 1910 • Strong incluído",
    markAsRead: "Passagem lida",
    alreadyRead: "Já lido",
    readingBonus: "Bônus de leitura",
    results: "resultados",
    result: "resultado",
    copy: "Copiar",
    image: "Imagem"
  },

  mountain: {
    chapter: "Capítulo",
    secret: "Segredo!",
    spiritualAscension: "Ascensão Espiritual",
    levelProgress: "Nível {{level}} • {{stars}} estrelas obtidas",
    combo: "Combo",
    perfectMessage: '"Porque os meus pensamentos não são os vossos pensamentos" - O cordeiro sobe em direção à sabedoria perfeita',
    goodMessage: '"Buscai e achareis" - A subida continua em direção à verdade',
    startMessage: '"A fé, mesmo pequena como um grão de mostarda" - Primeiro passo em direção à luz',
    skipAnimation: "Pular animação",
    stats: {
      points: "pts",
      level: "Nív."
    },
    waypoints: {
      start: "Partida",
      firstSlope: "Primeira inclinação",
      lastSlope: "Última inclinação"
    },
    status: {
      victory: "Vitória!",
      defeat: "Derrota",
      inProgress: "Em andamento"
    }
  },

  bibleResources: {
    inAppReader: {
      name: "Ler no App",
      description: "Leitor da Bíblia integrado com Strong",
      features: {
        offline: "Offline",
        strong: "Números Strong",
        navigation: "Navegação"
      }
    }
  },

  quotes: {
    wisdom: "O verdadeiro conhecimento leva à sabedoria eterna",
    faith: "Tudo posso naquele que me fortalece",
    hope: "O Senhor é o meu pastor, nada me faltará",
    love: "Porque Deus amou o mundo de tal maneira...",
    perseverance: "A fé requer perseverança",
    defeat: "O fracasso convida a crescer no conhecimento"
  },

  philosophy: {
    title: "Dimensão filosófica",
    loveOntology: "O amor como princípio ontológico",
    loveDescription: "Jesus transforma o amor em fundamento metafísico: amar a Deus e ao próximo torna-se a própria estrutura do ser autêntico. O amor transcende a moral para tornar-se modo de existência.",
    newCommandment: "O Novo Mandamento",
    jesusEmphasizes: "Quando Jesus dá um novo mandamento, ele enfatiza o verbo amar",
    loveGod: "Ama a Deus de todo o teu coração",
    loveNeighbor: "Ama o teu próximo como a ti mesmo",
    lovePriority: "O amor torna-se uma prioridade"
  },

  unity: unityTranslations,

  footer: {
    version: "Versão 1.0 • 2024",
    dedication: "Desenvolvido para a glória de Deus"
  },

  endCredits: {
    lines: [
      { text: "Você chegou ao topo da montanha", delay: 2000 },
      { text: "Você aprendeu muitas coisas", delay: 2000 },
      { text: "Sua fé cresce a cada dia", delay: 2000 },
      { text: "Você vive coisas belas com Deus", delay: 2000 },
      { text: "As dificuldades te ajudam a crescer", delay: 2000 },
      { text: "Elas mostram o que é importante", delay: 2000 },
      { text: "Sê humilde como uma criança", delay: 2000 },
      { text: "Deus ama teu coração simples", delay: 2000 },
      { text: "Na calma você ouve Deus", delay: 2000 },
      { text: "O jejum libera teu espírito", delay: 2000 },
      { text: "Reza e Deus te guiará", delay: 2000 },
      { text: "O orgulho esconde a verdade", delay: 2000 },
      { text: "A graça de Deus é magnífica", delay: 2000 },
      { text: "Ela vem do coração de Deus", delay: 2000 },
      { text: "A verdadeira fé te torna livre", delay: 2000 },
      { text: "Ela te une a Deus para sempre", delay: 2000 },
      { text: "O amor pode mudar tudo", delay: 2000 },
      { text: "Ele pode fazer milagres", delay: 2000 },
      { text: "Repita comigo", delay: 2000 },
      { text: "Jesus, eu te dou meu coração", delay: 3000 },
      { text: "Tu és meu rei, meu salvador", delay: 3000 },
      { text: "Vem transformar minha vida", delay: 3000 },
      { text: "O caminho continua agora", delay: 2000 },
      { text: "Compartilhe esta bela luz", delay: 2000 },
      { text: "Rumo à vida que nunca termina", delay: 2000 },
      { text: "Guarda o amor em teu coração", delay: 3000 },
      { text: "Como um tesouro precioso", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "PARABÉNS!",
      proud: "ESTAMOS ORGULHOSOS DE VOCÊ",
      courage: "CORAGEM VALOROSO",
      peace: "PORTADOR DA PAZ",
      child: "FILHO DE DEUS",
      blessing: "QUE DEUS TE ABENÇOE",
      continue: "Continuar"
    }
  },

  validation: {
    pseudoTooShort: "O apelido deve conter pelo menos 2 caracteres",
    enterPseudo: "Por favor, insira um apelido"
  },

  pseudoSetup: {
    title: "Escolha seu apelido de jogador",
    profileConfig: "Configuração do Perfil",
    connectedWith: "Conectado com",
    playerPseudo: "Apelido de Jogador",
    pseudoPlaceholder: "Seu apelido...",
    pseudoRequirements: "2-20 caracteres • Exibido nas classificações",
    suggestions: "Sugestões",
    confirm: "Confirmar Apelido",
    errorConfig: "Erro durante a configuração"
  },

  navigation: {
    back: "Voltar"
  },

  console: {
    starsUnlocked: "estrelas alcançadas! Desbloqueio de capítulo",
    defeatAnimation: "Derrota... J.C. desce novamente"
  },

  errors: {
    progressionError: "Erro de progressão",
    invalidProgressionData: "Dados de progressão inválidos:"
  },

  levels: {
    chaptersAndBonus: "8 capítulos + nível bônus",
    bonusUnlocked: "🎁 NÍVEL BÔNUS DESBLOQUEADO! Você alcançou a perfeição espiritual!",
    starsToDiscover: "273 {stars} a descobrir",
    starsPerLevel: "3 {stars} por nível"
  },

  architecture: {
    title: "⚙️ Arquitetura técnica",
    react: {
      name: "React",
      description: "Interface moderna"
    },
    modules: {
      name: "Módulos",
      description: "Carregamento dinâmico"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Salvamento local"
    },
    tailwind: {
      name: "Tailwind",
      description: "Design responsivo"
    }
  },

  gameManager: {
    title: "Salvamento de jogo",
    saveLocal: "Salvamento local",
    saveCloud: "Nuvem sincronizada",
    saveWaiting: "Aguardando conexão",
    lastSave: "Último salvamento:",
    never: "Nunca",
    saving: "Salvando...",
    save: "Salvar",
    loadProgress: "Carregar",
    loading: "Carregando...",
    autoSaveEnabled: "💾 Salvamento automático ativado",
    saveError: "❌ Erro ao salvar",
    gameSaved: "✅ Jogo salvo!",
    gameLoaded: "✅ Jogo carregado!"
  }
};

export default uiTranslations;
